var _defs, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 223.19 222.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#15e6c6;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.59,58.81,159.71,10.7A111.58,111.58,0,0,0,117.8,0L59,58.81h0A37.18,37.18,0,0,0,111.59,58.81Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.59,164,63.48,212.15a111.77,111.77,0,0,0,41.91,10.7L164.2,164A37.22,37.22,0,0,0,111.59,164Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.71,51.07A111.49,111.49,0,0,0,.17,117.63L59,58.81A37.21,37.21,0,0,0,17.71,51.07Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59,111.42,10.87,159.54a111.69,111.69,0,0,0,21.81,30.8h0l78.91-78.92h0A37.2,37.2,0,0,0,59,111.42Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M164.2,111.42l48.12-48.11a111.39,111.39,0,0,0-21.81-30.8l-78.92,78.91A37.2,37.2,0,0,0,164.2,111.42Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M223,105.22,164.2,164h0a37.19,37.19,0,0,0,41.28,7.75A111.49,111.49,0,0,0,223,105.22Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenLogo);
export default __webpack_public_path__ + "static/media/green_logo.bff8b063e20cf46f221f753573d471a9.svg";
export { ForwardRef as ReactComponent };